export default __webpack_public_path__ + "static/media/SWT1180.34I-43200_-25824_0.fcf75b55.jpg";